module.exports = __webpack_public_path__ + "img/template_story_1.692c430e.png";